import App from './App';
import './i18n';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
} from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { UserProvider } from '@/context/userContext';
import LoginPage from './pages/auth/LoginPage';
import NavigationDrawer from './common/components/NavigationDrawer';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import EmailVerifyPage from './pages/auth/EmailVerifyPage';
import RequireAuth from './pages/auth/RequireAuth';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import NavigateWithState from './common/components/NavigateWithState';
import UserListSummaryPage from './pages/user-manage/user-list/UserListSummaryPage';
import UserInfoPage from './pages/user-manage/user-list/UserInfoPage';
import Page404 from './pages/404';
import ErrorPage from './pages/error-page';
import ErrorBoundary from './ErrorBoundary';
import ResetPasswordSuccessPage from './pages/auth/ResetPasswordSuccessPage';
import CreateUserPage from './pages/user-manage/user-list/CreateUserPage';
import DeleteUserRecordSummaryPage from './pages/user-manage/delete-user-record/DeleteUserRecordSummaryPage';
import StaffListSummaryPage from './pages/staff-manage/staff-list/StaffListSummaryPage';
import CreateStaffPage from './pages/staff-manage/staff-list/CreateStaffPage';
import StaffInfoPage from './pages/staff-manage/staff-list/StaffInfoPage';
import DeleteStaffRecordSummaryPage from './pages/staff-manage/delete-staff-record/DeleteStaffRecordSummaryPage';
import ClockListSummaryPage from './pages/app-setting/clock-list/ClockListSummaryPage';
import EmoSupportListSummaryPage from './pages/information-manage/emo-support-list/EmoSupportListSummaryPage';
import CreateEmoPage from './pages/information-manage/emo-support-list/CreateEmoPage';
import EmoDetailPage from './pages/information-manage/emo-support-list/EmoDetailPage';
import FaqListSummaryPage from './pages/information-manage/faq-list/FaqListSummaryPage';
import SubFaqListSummaryPage from './pages/information-manage/sub-faq-list/SubFaqListSummaryPage';
import CreateSubFaqPage from './pages/information-manage/sub-faq-list/CreateSubFaqPage';
import SubFaqDetailPage from './pages/information-manage/sub-faq-list/SubFaqDetailPage';
import AboutUsListSummaryPage from './pages/information-manage/about-us-list/AboutUsListSummaryPage';
import AboutUsCreatePage from './pages/information-manage/about-us-list/AboutUsCreatePage';
import AboutUsDetailPage from './pages/information-manage/about-us-list/AboutUsDetailPage';
import InformationListSummaryPage from './pages/information-manage/information-list/InformationListSummaryPage';
import InformationCreatePage from './pages/information-manage/information-list/InformationCreatePage';
import InformationDetailPage from './pages/information-manage/information-list/InformationDetailPage';
import ChapterCreatePage from './pages/information-manage/information-list/ChapterCreatePage ';
import ChapterDetailPage from './pages/information-manage/information-list/ChapterDetailPage';
import NotificationListSummaryPage from './pages/app-setting/notification-template/NotificationListSummaryPage';
import MeditationListSummaryPage from './pages/exercise-manage/meditation-list/MeditationListSummaryPage';
import MeditationCreatePage from './pages/exercise-manage/meditation-list/MeditationCreatePage';
import MeditationDetailPage from './pages/exercise-manage/meditation-list/MeditationDetailPage';
import SingleCreatePage from './pages/exercise-manage/meditation-list/SingleCreatePage';
import SingleDetailPage from './pages/exercise-manage/meditation-list/SingleDetailPage';
import BodyListSummaryPage from './pages/exercise-manage/body-list/BodyListSummaryPage';
import BodyCreatePage from './pages/exercise-manage/body-list/BodyCreatePage';
import BodyDetailPage from './pages/exercise-manage/body-list/BodyDetailPage';
import BodySingleCreatePage from './pages/exercise-manage/body-list/BodySingleCreatePage';
import BodySingleDetailPage from './pages/exercise-manage/body-list/BodySingleDetailPage';
import CrossoverListSummaryPage from './pages/exercise-manage/crossover-list/CrossoverListSummaryPage';
import CrossoverCreatePage from './pages/exercise-manage/crossover-list/CrossoverCreatePage';
import CrossoverDetailPage from './pages/exercise-manage/crossover-list/CrossoverDetailPage';
import CrossoverSingleCreatePage from './pages/exercise-manage/crossover-list/CrossoverSingleCreatePage';
import CrossoverSingleDetailPage from './pages/exercise-manage/crossover-list/CrossoverSingleDetailPage';
import Day21ListSummaryPage from './pages/exercise-manage/day21-list/Day21ListSummaryPage';
import Day21DetailPage from './pages/exercise-manage/day21-list/Day21DetailPage';
import Day21CreatePage from './pages/exercise-manage/day21-list/Day21CreatePage';
import Day21SingleDetailPage from './pages/exercise-manage/day21-list/Day21SingleDetailPage';
import Day21AdditionalCreatePage from './pages/exercise-manage/day21-list/Day21AdditionalCreatePage';
import MomentListSummaryPage from './pages/app-setting/moment-list/MomentListSummaryPage';
import MomentDetailPage from './pages/app-setting/moment-list/MomentDetailPage';
import HealthListSummaryPage from './pages/app-setting/health-list/HealthListSummaryPage';
import HealthDetailPage from './pages/app-setting/health-list/HealthDetailPage';
import DingDay21ListSummaryPage from './pages/exercise-manage/ding-day21/DingDay21ListSummaryPage';
import TopSeriesListSummaryPage from './pages/exercise-manage/top-series/TopSeriesListSummaryPage';
import TagListSummaryPage from './pages/exercise-manage/manage-tag/TagListSummaryPage';
import MajorListSummaryPage from './pages/exercise-manage/major-list/MajorListSummaryPage';
import MajorCreatePage from './pages/exercise-manage/major-list/MajorCreatePage';
import MajorDetailPage from './pages/exercise-manage/major-list/MajorDetailPage';
import MajorAdditionalCreatePage from './pages/exercise-manage/major-list/MajorAdditionalCreatePage';
import MajorAdditionalDetailPage from './pages/exercise-manage/major-list/MajorAdditionalDetailPage';
import Series21ProgressSummaryPage from './pages/user-manage/series-21-progress/Series21ProgressSummaryPage';
import UnlockSeries21SummaryPage from './pages/user-manage/unlock-series-21/UnlockSeries21SummaryPage';
import MajorProgressSummaryPage from './pages/user-manage/major-progress/MajorProgressSummaryPage';
import UnlockMajorSummaryPage from './pages/user-manage/unlock-major/UnlockMajorSummaryPage';
import ActivitySummaryPage from './pages/task-manage/activity-list/ActivitySummaryPage';
import ActivityCreatePage from './pages/task-manage/activity-list/ActivityCreatePage';
import ActivityDetailPage from './pages/task-manage/activity-list/ActivityDetailPage';
import ActivitySingleDetailPage from './pages/task-manage/activity-list/ActivitySingleDetailPage';
import ActivitySingleCreatePage from './pages/task-manage/activity-list/ActivitySingleCreatePage';
import AchievementSummaryPage from './pages/task-manage/achievement-list/AchievementSummaryPage';
import AchievementCreatePage from './pages/task-manage/achievement-list/AchievementCreatePage';
import AchievementDetailPage from './pages/task-manage/achievement-list/AchievementDetailPage';
import AchievementSingleDetailPage from './pages/task-manage/achievement-list/AchievementSingleDetailPage';
import AchievementSingleCreatePage from './pages/task-manage/achievement-list/AchievementSingleCreatePage';
import TreasureDetailPage from './pages/task-manage/treasure-list/TreasureDetailPage';
import TreasureSummaryPage from './pages/task-manage/treasure-list/TreasureSummaryPage';
import RegularSummaryPage from './pages/task-manage/regular-day-list/RegularDaySummaryPage';
import RegularCreatePage from './pages/task-manage/regular-day-list/RegularDayCreatePage';
import RegularDetailPage from './pages/task-manage/regular-day-list/RegularDayDetailPage';
import RegularWeekSummaryPage from './pages/task-manage/regular-week-list/RegularWeekSummaryPage';
import RegularWeekCreatePage from './pages/task-manage/regular-week-list/RegularWeekCreatePage';
import RegularWeekDetailPage from './pages/task-manage/regular-week-list/RegularWeekDetailPage';
import RegularMonthSummaryPage from './pages/task-manage/regular-month-list/RegularMonthSummaryPage';
import RegularMonthCreatePage from './pages/task-manage/regular-month-list/RegularMonthCreatePage';
import RegularMonthDetailPage from './pages/task-manage/regular-month-list/RegularMonthDetailPage';
import ChartletSummaryPage from './pages/treasury-manage/chartlet-list/ChartletSummaryPage';
import ChartletDetailPage from './pages/treasury-manage/chartlet-list/ChartletDetailPage';
import ChartletCreatePage from './pages/treasury-manage/chartlet-list/ChartletCreatePage';
import ChartletSingleDetailPage from './pages/treasury-manage/chartlet-list/ChartletSingleDetailPage';
import ChartletSingleCreatePage from './pages/treasury-manage/chartlet-list/ChartletSingleCreatePage';
import WishSummaryPage from './pages/treasury-manage/wish-list/WishSummaryPage';
import WishCreatePage from './pages/treasury-manage/wish-list/WishCreatePage';
import WishDetailPage from './pages/treasury-manage/wish-list/WishDetailPage';
import WishSingleDetailPage from './pages/treasury-manage/wish-list/WishSingleDetailPage';
import WishSingleCreatePage from './pages/treasury-manage/wish-list/WishSingleCreatePage';
import StampSummaryPage from './pages/treasury-manage/stamp-list/StampSummaryPage';
import StampCreatePage from './pages/treasury-manage/stamp-list/StampCreatePage';
import StampDetailPage from './pages/treasury-manage/stamp-list/StampDetailPage';
import StampSingleDetailPage from './pages/treasury-manage/stamp-list/StampSingleDetailPage';
import StampSingleCreatePage from './pages/treasury-manage/stamp-list/StampSingleCreatePage';
import PuzzleSingleCreatePage from './pages/treasury-manage/puzzle-list/PuzzleSingleCreatePage';
import PuzzleSingleDetailPage from './pages/treasury-manage/puzzle-list/PuzzleSingleDetailPage';
import PuzzleDetailPage from './pages/treasury-manage/puzzle-list/PuzzleDetailPage';
import PuzzleCreatePage from './pages/treasury-manage/puzzle-list/PuzzleCreatePage';
import PuzzleSummaryPage from './pages/treasury-manage/puzzle-list/PuzzleSummaryPage';
import GallerySingleCreatePage from './pages/treasury-manage/gallery-list/GallerySingleCreatePage';
import GallerySingleDetailPage from './pages/treasury-manage/gallery-list/GallerySingleDetailPage';
import GalleryDetailPage from './pages/treasury-manage/gallery-list/GalleryDetailPage';
import GalleryCreatePage from './pages/treasury-manage/gallery-list/GalleryCreatePage';
import GallerySummaryPage from './pages/treasury-manage/gallery-list/GallerySummaryPage';
import TreasureSingleDetailPage from './pages/task-manage/treasure-list/TreasureSingleDetailPage';
import TreasureSingleCreatePage from './pages/task-manage/treasure-list/TreasureSingleCreatePage';
import RuleSummaryPage from './pages/task-manage/rule-list/RuleSummaryPage';
import RuleInfoPage from './pages/task-manage/rule-list/RuleInfoPage';
import DialogListSummaryPage from './pages/app-setting/dialog-list/DialogListSummaryPage';
import DialogDetailPage from './pages/app-setting/dialog-list/DialogDetailPage';
import DialogCreatePage from './pages/app-setting/dialog-list/DialogCreatePage';
import ExplainPage from './pages/treasury-manage/explain/ExplainPage';
import WeekTreasureListSummaryPage from './pages/exchange-manage/week-treasure/WeekTreasureListSummaryPage';
import MysteryBoxSummaryPage from './pages/exchange-manage/mystery-box/MysteryBoxSummaryPage';
import MysteryBoxCreatePage from './pages/exchange-manage/mystery-box/MysteryBoxCreatePage';
import MysteryBoxDetailPage from './pages/exchange-manage/mystery-box/MysteryBoxDetailPage';
import MysteryBoxSingleCreatePage from './pages/exchange-manage/mystery-box/MysteryBoxSingleCreatePage';
import MysteryBoxSingleDetailPage from './pages/exchange-manage/mystery-box/MysteryBoxSingleDetailPage';
import ReportListSummaryPage from './pages/report-manage/report-list/ReportListSummaryPage';

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path='error-page' element={<ErrorPage />} />
			<Route
				path=''
				element={
					<ErrorBoundary>
						<App />
					</ErrorBoundary>
				}
			>
				<Route path='*' element={<Page404 />} />
				<Route path='login' element={<Outlet />}>
					<Route index element={<LoginPage />} />
				</Route>
				<Route path='forgot-password' element={<Outlet />}>
					<Route index element={<ForgotPasswordPage />} />
					<Route path='verify' element={<EmailVerifyPage />} />
					<Route path='reset' element={<ResetPasswordPage />} />
					<Route path='reset-success' element={<ResetPasswordSuccessPage />} />
				</Route>
				<Route element={<RequireAuth></RequireAuth>}>
					<Route path='app'>
						<Route index element={<NavigateWithState to='vouchers' />} />
					</Route>
					<Route
						path=''
						element={
							<UserProvider>
								<NavigationDrawer />
							</UserProvider>
						}
					>
						<Route path='user-manage'>
							<Route path='user-list'>
								<Route index element={<UserListSummaryPage />} />
								<Route path='add' element={<CreateUserPage />} />
								<Route path='info/:id' element={<UserInfoPage />} />
								<Route
									path='info/:id/series-21'
									element={<Series21ProgressSummaryPage />}
								/>
								<Route
									path='info/:id/series-21/:seriesId'
									element={<UnlockSeries21SummaryPage />}
								/>
								<Route
									path='info/:id/major'
									element={<MajorProgressSummaryPage />}
								/>
								<Route
									path='info/:id/major/:seriesId'
									element={<UnlockMajorSummaryPage />}
								/>
							</Route>
							<Route path='delete-user-record'>
								<Route index element={<DeleteUserRecordSummaryPage />} />
							</Route>
						</Route>
						<Route path='staff-manage'>
							<Route path='staff-list'>
								<Route index element={<StaffListSummaryPage />} />
								<Route path='add' element={<CreateStaffPage />} />
								<Route path='info/:id' element={<StaffInfoPage />} />
							</Route>
							<Route path='delete-staff-record'>
								<Route index element={<DeleteStaffRecordSummaryPage />} />
							</Route>
						</Route>
						<Route path='information-manage'>
							<Route path='information-list'>
								<Route index element={<InformationListSummaryPage />} />
								<Route path='add' element={<InformationCreatePage />} />
								<Route
									path='info/:informationId'
									element={<InformationDetailPage />}
								/>
								<Route
									path='info/:informationId/add'
									element={<ChapterCreatePage />}
								/>
								<Route
									path='info/:informationId/chapter-info/:chapterId'
									element={<ChapterDetailPage />}
								/>
							</Route>
							<Route path='emo-support-list'>
								<Route index element={<EmoSupportListSummaryPage />} />
								<Route path='add' element={<CreateEmoPage />} />
								<Route path='info/:emoId' element={<EmoDetailPage />} />
							</Route>
							<Route path='faq-list'>
								<Route index element={<FaqListSummaryPage />} />
								<Route path='sub-faq-list/:faqId'>
									<Route index element={<SubFaqListSummaryPage />} />
									<Route path='add' element={<CreateSubFaqPage />} />
									<Route
										path='info/:questionId'
										element={<SubFaqDetailPage />}
									/>
								</Route>
							</Route>
							<Route path='about-us-list'>
								<Route index element={<AboutUsListSummaryPage />} />
								<Route path='add' element={<AboutUsCreatePage />} />
								<Route path='info/:aboutId' element={<AboutUsDetailPage />} />
							</Route>
						</Route>
						<Route path='exercise-manage'>
							<Route path='day21-list'>
								<Route index element={<Day21ListSummaryPage />} />
								<Route path='add' element={<Day21CreatePage />} />
								<Route path='info/:day21Id'>
									<Route index element={<Day21DetailPage />} />
									<Route
										path='detail/:day21SingleId'
										element={<Day21SingleDetailPage />}
									/>
									<Route
										path='detail/:day21SingleId/additional'
										element={<Day21AdditionalCreatePage />}
									/>
								</Route>
							</Route>
							<Route path='meditation-list'>
								<Route index element={<MeditationListSummaryPage />} />
								<Route path='add' element={<MeditationCreatePage />} />
								<Route path='info/:meditationId'>
									<Route index element={<MeditationDetailPage />} />
									<Route path='add' element={<SingleCreatePage />} />
									<Route
										path='detail/:meditationSingleId'
										element={<SingleDetailPage />}
									/>
								</Route>
							</Route>
							<Route path='body-list'>
								<Route index element={<BodyListSummaryPage />} />
								<Route path='add' element={<BodyCreatePage />} />
								<Route path='info/:bodyId'>
									<Route index element={<BodyDetailPage />} />
									<Route path='add' element={<BodySingleCreatePage />} />
									<Route
										path='detail/:bodySingleId'
										element={<BodySingleDetailPage />}
									/>
								</Route>
							</Route>
							<Route path='crossover-list'>
								<Route index element={<CrossoverListSummaryPage />} />
								<Route path='add' element={<CrossoverCreatePage />} />
								<Route path='info/:crossoverId'>
									<Route index element={<CrossoverDetailPage />} />
									<Route path='add' element={<CrossoverSingleCreatePage />} />
									<Route
										path='detail/:crossoverSingleId'
										element={<CrossoverSingleDetailPage />}
									/>
								</Route>
							</Route>
							<Route path='ding-day21'>
								<Route index element={<DingDay21ListSummaryPage />} />
							</Route>
							<Route path='top-series'>
								<Route index element={<TopSeriesListSummaryPage />} />
							</Route>
							<Route path='manage-tag'>
								<Route index element={<TagListSummaryPage />} />
							</Route>
							<Route path='major-list'>
								<Route index element={<MajorListSummaryPage />} />
								<Route path='add' element={<MajorCreatePage />} />
								<Route path='info/:majorId'>
									<Route index element={<MajorDetailPage />} />
									<Route
										path='detail/:majorSingleId'
										element={<MajorAdditionalDetailPage />}
									/>
									<Route path='add' element={<MajorAdditionalCreatePage />} />
								</Route>
							</Route>
						</Route>
						<Route path='app-setting'>
							<Route path='clock-list'>
								<Route index element={<ClockListSummaryPage />} />
							</Route>
							<Route path='notification-list'>
								<Route index element={<NotificationListSummaryPage />} />
							</Route>
							<Route path='moment-list'>
								<Route index element={<MomentListSummaryPage />} />
								<Route path='info/:momentId'>
									<Route index element={<MomentDetailPage />} />
								</Route>
							</Route>
							<Route path='health-list'>
								<Route index element={<HealthListSummaryPage />} />
								<Route path='info/:healthId'>
									<Route index element={<HealthDetailPage />} />
								</Route>
							</Route>
							<Route path='dialog-list'>
								<Route index element={<DialogListSummaryPage />} />
								<Route path='add' element={<DialogCreatePage />} />
								<Route path='info/:dialogId'>
									<Route index element={<DialogDetailPage />} />
								</Route>
							</Route>
						</Route>
						<Route path='task-manage'>
							<Route path='activity-list'>
								<Route index element={<ActivitySummaryPage />} />
								<Route path='add' element={<ActivityCreatePage />} />
								<Route path='info/:activityId'>
									<Route index element={<ActivityDetailPage />} />
									<Route
										path='detail/:activitySingleId'
										element={<ActivitySingleDetailPage />}
									/>
									<Route path='add' element={<ActivitySingleCreatePage />} />
								</Route>
							</Route>
							<Route path='achievement-list'>
								<Route index element={<AchievementSummaryPage />} />
								<Route path='add' element={<AchievementCreatePage />} />
								<Route path='info/:achievementId'>
									<Route index element={<AchievementDetailPage />} />
									<Route
										path='detail/:achievementSingleId'
										element={<AchievementSingleDetailPage />}
									/>
									<Route path='add' element={<AchievementSingleCreatePage />} />
								</Route>
								<Route path='treasure'>
									<Route index element={<TreasureSummaryPage />} />
									<Route path='info/:treasureId'>
										<Route index element={<TreasureDetailPage />} />
										<Route
											path='detail/:treasureSingleId'
											element={<TreasureSingleDetailPage />}
										/>
										<Route path='add' element={<TreasureSingleCreatePage />} />
									</Route>
								</Route>
							</Route>

							<Route path='regular-day-list'>
								<Route index element={<RegularSummaryPage />} />
								<Route path='add' element={<RegularCreatePage />} />
								<Route path='info/:regularDayId'>
									<Route index element={<RegularDetailPage />} />
								</Route>
								<Route path='week'>
									<Route index element={<RegularWeekSummaryPage />} />
									<Route path='add' element={<RegularWeekCreatePage />} />
									<Route path='info/:regularWeekId'>
										<Route index element={<RegularWeekDetailPage />} />
									</Route>
								</Route>
								<Route path='month'>
									<Route index element={<RegularMonthSummaryPage />} />
									<Route path='add' element={<RegularMonthCreatePage />} />
									<Route path='info/:regularMonthId'>
										<Route index element={<RegularMonthDetailPage />} />
									</Route>
								</Route>
							</Route>
							<Route path='rule-list'>
								<Route index element={<RuleSummaryPage />} />
								<Route path='info/:ruleId'>
									<Route index element={<RuleInfoPage />} />
								</Route>
							</Route>
						</Route>
						<Route path='treasury-manage'>
							<Route path='gallery-list'>
								<Route index element={<GallerySummaryPage />} />
								<Route path='add' element={<GalleryCreatePage />} />
								<Route path='info/:galleryId'>
									<Route index element={<GalleryDetailPage />} />
									<Route
										path='detail/:gallerySingleId'
										element={<GallerySingleDetailPage />}
									/>
									<Route path='add' element={<GallerySingleCreatePage />} />
								</Route>
							</Route>
							<Route path='puzzle-list'>
								<Route index element={<PuzzleSummaryPage />} />
								<Route path='add' element={<PuzzleCreatePage />} />
								<Route path='info/:puzzleId'>
									<Route index element={<PuzzleDetailPage />} />
									<Route
										path='detail/:puzzleSingleId'
										element={<PuzzleSingleDetailPage />}
									/>
									<Route path='add' element={<PuzzleSingleCreatePage />} />
								</Route>
							</Route>
							<Route path='stamp-list'>
								<Route index element={<StampSummaryPage />} />
								<Route path='add' element={<StampCreatePage />} />
								<Route path='info/:stampId'>
									<Route index element={<StampDetailPage />} />
									<Route
										path='detail/:stampSingleId'
										element={<StampSingleDetailPage />}
									/>
									<Route path='add' element={<StampSingleCreatePage />} />
								</Route>
							</Route>
							<Route path='wish-list'>
								<Route index element={<WishSummaryPage />} />
								<Route path='add' element={<WishCreatePage />} />
								<Route path='info/:wishId'>
									<Route index element={<WishDetailPage />} />
									<Route
										path='detail/:wishSingleId'
										element={<WishSingleDetailPage />}
									/>
									<Route path='add' element={<WishSingleCreatePage />} />
								</Route>
							</Route>
							<Route path='chartlet-list'>
								<Route index element={<ChartletSummaryPage />} />
								<Route path='add' element={<ChartletCreatePage />} />
								<Route path='info/:chartletId'>
									<Route index element={<ChartletDetailPage />} />
									<Route
										path='detail/:chartletSingleId'
										element={<ChartletSingleDetailPage />}
									/>
									<Route path='add' element={<ChartletSingleCreatePage />} />
								</Route>
							</Route>
							<Route path='explain'>
								<Route index element={<ExplainPage />} />
							</Route>
						</Route>
						<Route path='exchange-manage'>
							<Route path='mystery-box'>
								<Route index element={<MysteryBoxSummaryPage />} />
								<Route path='add' element={<MysteryBoxCreatePage />} />
								<Route path='info/:boxId'>
									<Route index element={<MysteryBoxDetailPage />} />
									<Route
										path='detail/:boxSingleId'
										element={<MysteryBoxSingleDetailPage />}
									/>
									<Route path='add' element={<MysteryBoxSingleCreatePage />} />
								</Route>
							</Route>
							<Route path='week-treasure'>
								<Route index element={<WeekTreasureListSummaryPage />} />
							</Route>
						</Route>
						<Route path='report-manage'>
							<Route path='report-list'>
								<Route index element={<ReportListSummaryPage />} />
							</Route>
						</Route>
					</Route>
				</Route>
			</Route>
		</>
	)
);

export default router;
